module.exports = __webpack_public_path__ + "static/media/client30.e1a123b5.webp";